import {
  Component
} from '@angular/core';


export class SkyFilterInlineItemComponent {
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-filter-inline-item',
  styles: [`.sky-filter-inline-item {
  margin-right: 10px;
}
`],
  template: `<div class="sky-filter-inline-item">
  <ng-content></ng-content>
</div>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
